import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { callAPI } from "../../../../axios";
import BasicModal from "../../../core/BaseComponents/Modal";
import approveQc from "../../../../assets/images/approve-qc.png";
import { Switch } from "@mui/material";

const CreateEditRole = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [addRolePopUp, setAddRolePopUp] = useState(false);
  const [roleSuccessMessage, setRoleSuccessMessage] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      active: true, // default value is true
    }
  });

  const onSubmit = (data) => {
    let payload;
    let apiPath;
    let method;
    setAddRolePopUp(true);
    if (location?.state?.isEditRole) {
      method = "PUT";
      const { id } = location?.state;
      payload = data;
      apiPath = `/role?sid=${id}`;
    } else {
      method = "POST";
      payload = data;
      apiPath = `/role`;
    }
    callAPI(apiPath, method, payload)
      .then((res) => setRoleSuccessMessage(res.message))
      .catch((err) => {
        console.warn(err.message);
        navigate("/hms/roles");
        setAddRolePopUp(false);
      });
  };

  const handleReset = () => {
    reset();
  };

  const handleCancelButton = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  useEffect(() => {
    if (location?.state?.isEditRole) {
      const { id } = location?.state;
      callAPI(`role?sid=${id}`, "GET")
        .then(function (response) {
          reset(response);
        })
        .catch(function (error) {
          console.warn(error.response?.data?.errorMessage);
        });
    }
  }, [location?.state, reset]);

  const navigateToRoleList = () => {
    setAddRolePopUp(false);
    navigate("/hms/roles");
  };

  const handleSwitchChange = (checked) => {
    setValue("active", checked);
  };

  return (
    <>
      <div className="breadcrumb">
        <ul>
          <li>
            <Link to="/hms/ConfigurationNewHotel">Dashboard </Link>{" "}
            <span className="arrow-color"> &gt; </span>
          </li>
          <li>
            <Link to="/hms/roles">Roles </Link>{" "}
            <span className="arrow-color"> &gt; </span>
          </li>
          <li>{location?.state?.isEditRole ? "Edit Role" : "Add New Role"}</li>
        </ul>
      </div>
      <div className="sub-header">
        <h1>{location?.state?.isEditRole ? "Edit Role" : "Add New Role"}</h1>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="create-edit-user">
        <div className="row">
          <div className="col-4">
            <label htmlFor="role">Role<span className="required">*</span></label>
            <input
              id="role"
              className="form-control"
              placeholder="Enter Role"
              type="text"
              {...register("role", { required: "Please Enter Role" })}
            />
            {errors.role && (
              <p className="required">{errors.role.message}</p>
            )}
          </div>

          <div className="col-4">
            <label htmlFor="roleCode">Role Code<span className="required">*</span></label>
            <input
              id="roleCode"
              className="form-control"
              placeholder="Enter Role Code"
              type="text"
              {...register("roleCode", { required: "Please Enter Role Code" })}
            />
            {errors.roleCode && (
              <p className="required">{errors.roleCode.message}</p>
            )}
          </div>
          <div className="col-6">
            <label htmlFor="active"> Status</label>
            <Switch
              id="active"
              className={`form-control border-0 ${watch("active")
                ? "switchuser-active"
                : "switchuser-inactive"
                }`}
              checked={watch("active")}
              onChange={handleSwitchChange}
              {...register("active")}
            />
          </div>
          <div className="button-group">
            <button
              type="button"
              className="cancel-btn_new"
              onClick={handleCancelButton}
            >
              Cancel
            </button>
            <button type="button" className="reset-btn" onClick={handleReset}>
              Reset
            </button>
            <button type="submit" className="create-btn">
              {location?.state?.isEditRole ? "Update Role" : "Add Role"}
            </button>
          </div>
        </div>
      </form>
      <BasicModal
        popupOpen={addRolePopUp}
        bodyMessage={
          <>
            <img src={approveQc} alt="approve" className="w-40px" />
            <p>{roleSuccessMessage}</p>
          </>
        }
        footer={{
          secondaryButton: {
            buttonName: "OK",
            action: navigateToRoleList,
          },
        }}
      />
    </>
  );
};

export default CreateEditRole;
